// // CheckInPage

// import { useState } from "react";

// import CheckInAccessGate from "../components/CheckInAccessGate";

// import {
//   searchRegistrationsForCheckIn,
//   markRegistrationAsCheckedIn,
// } from "../services/checkInService";

// export default function CheckInPage() {
//   const [isUnlocked, setIsUnlocked] = useState(false);
//   const [searchText, setSearchText] = useState("");
//   const [results, setResults] = useState([]);
//   const [status, setStatus] = useState("");

//   if (!isUnlocked) {
//     return <CheckInAccessGate onAccessGranted={() => setIsUnlocked(true)} />;
//   }

//   async function handleSearch(event) {
//     event.preventDefault();

//     setStatus("Searching...");

//     const response = await searchRegistrationsForCheckIn(searchText);

//     if (!response.success) {
//       setStatus(response.message);
//       return;
//     }

//     setResults(response.data);
//     setStatus(`${response.data.length} result(s) found.`);
//   }

//   async function handleCheckIn(registration) {
//     setStatus("Checking in guest...");

//     const response = await markRegistrationAsCheckedIn(
//       registration,
//       "check-in-staff"
//     );

//     setStatus(response.message);

//     if (response.success) {
//       setResults((previousResults) =>
//         previousResults.map((item) =>
//           item.id === registration.id
//             ? {
//                 ...item,
//                 checkedIn: true,
//               }
//             : item
//         )
//       );
//     }
//   }

//   return (
//     <main className="min-h-screen bg-twilight-indigo-950 px-5 py-10 text-white">
//       <section className="mx-auto max-w-4xl">
//         <div className="flex flex-col gap-5 border-b border-white/10 pb-8 md:flex-row md:items-end md:justify-between">
//           <div>
//             <p className="mb-4 text-xs font-semibold uppercase tracking-[0.4em] text-amber-flame-500">
//               ULFA 2026
//             </p>

//             <h1 className="font-display text-4xl font-bold md:text-6xl">
//               Check-In Station
//             </h1>

//             <p className="mt-4 text-slate-300">
//               Search for a registered guest by name, email, phone, organization,
//               or registration ID.
//             </p>
//           </div>

//           <button
//             type="button"
//             onClick={() => {
//               setIsUnlocked(false);
//               setSearchText("");
//               setResults([]);
//               setStatus("");
//             }}
//             className="border border-white/15 px-5 py-3 text-xs font-bold uppercase tracking-[0.2em] text-white transition hover:border-amber-flame-500 hover:text-amber-flame-400"
//           >
//             Lock
//           </button>
//         </div>

//         <form
//           onSubmit={handleSearch}
//           className="mt-8 flex flex-col gap-3 sm:flex-row"
//         >
//           <input
//             type="text"
//             value={searchText}
//             onChange={(event) => setSearchText(event.target.value)}
//             placeholder="Search guest..."
//             className="registration-field flex-1 border border-white/15 bg-twilight-indigo-900 px-5 py-4 text-base text-white outline-none focus:border-amber-flame-500"
//           />

//           <button
//             type="submit"
//             className="min-h-[56px] bg-amber-flame-500 px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-twilight-indigo-950 transition hover:bg-amber-flame-400"
//           >
//             Search
//           </button>
//         </form>

//         {status && (
//           <div className="mt-6 border border-white/10 bg-white/5 px-4 py-4 text-sm text-slate-200">
//             {status}
//           </div>
//         )}

//         <div className="mt-8 space-y-4">
//           {results.map((registration) => (
//             <article
//               key={registration.id}
//               className="border border-white/10 bg-white/5 p-5"
//             >
//               <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
//                 <div>
//                   <h2 className="font-serif text-2xl text-white">
//                     {registration.fullName}
//                   </h2>

//                   <p className="mt-1 text-sm text-slate-400">
//                     {registration.email} · {registration.phone}
//                   </p>

//                   <p className="mt-2 text-sm text-slate-300">
//                     {registration.organizationName}
//                     {registration.college ? ` · ${registration.college}` : ""}
//                     {registration.department
//                       ? ` · ${registration.department}`
//                       : ""}
//                   </p>

//                   <p className="mt-2 text-xs uppercase tracking-[0.25em] text-amber-flame-500">
//                     {registration.checkedIn
//                       ? "Already Checked In"
//                       : "Registered"}
//                   </p>
//                 </div>

//                 <button
//                   type="button"
//                   disabled={registration.checkedIn}
//                   onClick={() => handleCheckIn(registration)}
//                   className="min-h-[48px] bg-amber-flame-500 px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] text-twilight-indigo-950 transition hover:bg-amber-flame-400 disabled:cursor-not-allowed disabled:opacity-40"
//                 >
//                   {registration.checkedIn ? "Checked In" : "Check In"}
//                 </button>
//               </div>
//             </article>
//           ))}
//         </div>
//       </section>
//     </main>
//   );
// }

// CheckInPage

import { useState } from "react";

import CheckInAccessGate from "../components/CheckInAccessGate";

import {
  searchRegistrationsForCheckIn,
  markRegistrationAsCheckedIn,
} from "../services/checkInService";

export default function CheckInPage() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState([]);
  const [status, setStatus] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  if (!isUnlocked) {
    return <CheckInAccessGate onAccessGranted={() => setIsUnlocked(true)} />;
  }

  function resetStation() {
    setIsUnlocked(false);
    setSearchText("");
    setResults([]);
    setStatus("");
    setIsProcessing(false);
  }

  async function handleSearch(event) {
    event.preventDefault();

    const trimmedSearchText = searchText.trim();

    if (!trimmedSearchText) {
      setStatus("Please enter a name, email, phone, organization, or registration ID.");
      setResults([]);
      return;
    }

    setIsProcessing(true);
    setStatus("Searching...");

    const response = await searchRegistrationsForCheckIn(trimmedSearchText);

    setIsProcessing(false);

    if (!response.success) {
      setStatus(response.message);
      return;
    }

    setResults(response.data);
    setStatus(`${response.data.length} result(s) found.`);
  }

  function clearSearch() {
    setSearchText("");
    setResults([]);
    setStatus("");
    setIsProcessing(false);
  }

  async function handleCheckIn(registration) {
    setIsProcessing(true);
    setStatus("Checking in guest...");

    const response = await markRegistrationAsCheckedIn(
      registration,
      "check-in-staff"
    );

    setIsProcessing(false);
    setStatus(response.message);

    if (response.success) {
      setResults((previousResults) =>
        previousResults.map((item) =>
          item.id === registration.id
            ? {
                ...item,
                checkedIn: true,
              }
            : item
        )
      );
    }
  }

  return (
    <main className="min-h-screen bg-twilight-indigo-950 px-5 py-10 text-white">
      <section className="mx-auto max-w-4xl">
        <div className="flex flex-col gap-5 border-b border-white/10 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.4em] text-amber-flame-500">
              ULFA 2026
            </p>

            <h1 className="font-display text-4xl font-bold md:text-6xl">
              Check-In Station
            </h1>

            <p className="mt-4 text-slate-300">
              Search for a registered guest by name, email, phone, organization,
              or registration ID.
            </p>
          </div>

          <button
            type="button"
            onClick={resetStation}
            className="self-start border border-white/10 px-4 py-2 text-[0.65rem] font-bold uppercase tracking-[0.2em] text-slate-400 transition hover:border-amber-flame-500 hover:text-amber-flame-400 md:self-end"
          >
            Lock Station
          </button>
        </div>

        {/* <form
          onSubmit={handleSearch}
          className="mt-8 flex flex-col gap-3 sm:flex-row"
        >
          <input
            type="text"
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            placeholder="Search guest..."
            className="registration-field flex-1 border border-white/15 bg-twilight-indigo-900 px-5 py-4 text-base text-white outline-none focus:border-amber-flame-500"
          />

          <button
            type="submit"
            disabled={isProcessing}
            className="min-h-[56px] bg-amber-flame-500 px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-twilight-indigo-950 transition hover:bg-amber-flame-400 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Search
          </button>
        </form> */}

        <form
          onSubmit={handleSearch}
          className="mt-8 flex flex-col gap-3 sm:flex-row"
        >
          <div className="relative flex-1">
            <input
              type="text"
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              placeholder="Search guest..."
              className="registration-field w-full border border-white/15 bg-twilight-indigo-900 px-5 py-4 pr-24 text-base text-white outline-none focus:border-amber-flame-500"
            />

            {searchText && (
              <button
                type="button"
                onClick={clearSearch}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-[0.65rem] font-bold uppercase tracking-[0.18em] text-slate-500 transition hover:text-amber-flame-400"
              >
                Clear
              </button>
            )}
          </div>

          <button
            type="submit"
            disabled={isProcessing}
            className="min-h-[56px] bg-amber-flame-500 px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-twilight-indigo-950 transition hover:bg-amber-flame-400 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Search
          </button>
        </form>

        {status && (
          <div
            className={`mt-6 flex items-center gap-3 border px-4 py-4 text-sm ${
              isProcessing
                ? "border-amber-flame-500/50 bg-amber-flame-950/30 text-amber-flame-100"
                : "border-white/10 bg-white/5 text-slate-200"
            }`}
          >
            {isProcessing && (
              <span
                className="h-4 w-4 animate-spin border-2 border-amber-flame-500 border-t-transparent"
                aria-hidden="true"
              />
            )}

            <span>{status}</span>
          </div>
        )}

        <div className="mt-8 space-y-4">
          {results.map((registration) => (
            <article
              key={registration.id}
              className="border border-white/10 bg-white/5 p-5"
            >
              <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div>
                  <h2 className="font-serif text-2xl text-white">
                    {registration.fullName}
                  </h2>

                  <p className="mt-1 text-sm text-slate-400">
                    {registration.email} · {registration.phone}
                  </p>

                  <p className="mt-2 text-sm text-slate-300">
                    {registration.organizationName}
                    {registration.college ? ` · ${registration.college}` : ""}
                    {registration.department
                      ? ` · ${registration.department}`
                      : ""}
                  </p>

                  <p className="mt-2 text-xs uppercase tracking-[0.25em] text-amber-flame-500">
                    {registration.checkedIn
                      ? "Already Checked In"
                      : "Registered"}
                  </p>
                </div>

                <button
                  type="button"
                  disabled={registration.checkedIn || isProcessing}
                  onClick={() => handleCheckIn(registration)}
                  className="min-h-[48px] bg-amber-flame-500 px-6 py-3 text-xs font-bold uppercase tracking-[0.2em] text-twilight-indigo-950 transition hover:bg-amber-flame-400 disabled:cursor-not-allowed disabled:opacity-40"
                >
                  {registration.checkedIn ? "Checked In" : "Check In"}
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}